import { render, staticRenderFns } from "./TheDarkModeButton.vue?vue&type=template&id=32b56898&scoped=true&"
import script from "./TheDarkModeButton.vue?vue&type=script&lang=ts&"
export * from "./TheDarkModeButton.vue?vue&type=script&lang=ts&"
import style0 from "./TheDarkModeButton.vue?vue&type=style&index=0&id=32b56898&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b56898",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EsTooltip: require('/app/src/components/common/EsTooltip.vue').default})
